import React, { useEffect, useState } from 'react';
import './HomeScreen.css';
import '../../Librarian/Reports/ReportDashboard.css';
import 'boxicons/css/boxicons.min.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import * as Constants from '../../Constant/constant';
import { useAuth } from '../../Constant/Auth';
import { getUserDataById } from '../../api/api';

const ParentDashboard = () => {
  const navigate = useNavigate();
  const { user, roleId } = useAuth();

  const [currentUser, setCurrentUser] = useState(null);
  const [issuedCount, setIssuedCount] = useState(0);
  const [userImg, setUserImg] = useState(null);
  const [loading, setLoading] = useState(true);

  const getImageUrl = (path) => {
    if (!path) return null;

    if (String(path).startsWith('http')) {
      return path;
    }

    const cleanPath = String(path).replace(/\\/g, '/').replace(/^\/+/, '');
    return `${Constants.IMAGE_BASE_URL}/${cleanPath}`;
  };

  const fetchUserData = async () => {
    try {
      if (!user?.id) return;

      setLoading(true);

      const userData = (await getUserDataById(user.id)) || {};

      setCurrentUser(userData);
      setUserImg(userData.user_img || userData.image || userData.profile_image || null);
    } catch (err) {
      console.error('Error fetching user data:', err);
      setCurrentUser(user || null);
      setUserImg(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchIssuedCount = async () => {
    try {
      if (!user?.id) return;

      const res = await axios.get(
        `${Constants.API_PATH}/count-issued-book-for-parents/${user.id}`
      );

      setIssuedCount(res.data?.count || 0);
    } catch (err) {
      console.error('Error fetching issued book count:', err);
      setIssuedCount(0);
    }
  };

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  useEffect(() => {
    fetchIssuedCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  if (loading || !user) {
    return (
      <div className="container-fluid mt-3">
        <div className="text-center py-5">Loading...</div>
      </div>
    );
  }

  const finalUser = currentUser || user;

  const finalRoleId =
    finalUser?.role_id ||
    finalUser?.roleId ||
    roleId ||
    user?.role_id;

  const finalStatus =
    finalUser?.status !== undefined && finalUser?.status !== null
      ? Number(finalUser.status)
      : Number(user?.status);

  // Tumhare data me role_id 5 aa raha hai, isliye 4 aur 5 dono allow kiye hain
  const isParentRole = ['4', '5'].includes(String(finalRoleId));
  const isApproved = finalStatus !== 0;

  if (!isApproved || !isParentRole) {
    return (
      <div className="containerunauth">
        <div className="col-md-12 aut">
          You are unauthorized. Your school librarian needs to approve your registration request.
          <br />
          In case of query, please contact{' '}
          <strong>community.lib@jaipuria.edu.in</strong>.
        </div>
      </div>
    );
  }

  const displayName =
    finalUser.first_name ||
    finalUser.full_name ||
    finalUser.name ||
    finalUser.parent_name ||
    'Parent';

  // Cool blue palette matched to the periwinkle sidebar (royal/indigo/teal accents)
  const tiles = [
    { c: '#2563eb', icon: 'bx bx-search-alt', title: 'Find Books', desc: 'Search & request books', path: '/parent-book-list' },
    { c: '#6d28d9', icon: 'bx bx-list-check', title: 'My Requests', desc: 'Track your book requests', path: '/parent-requests' },
    { c: '#0f766e', icon: 'bx bx-book-reader', title: 'Issued Books', desc: "Books you've borrowed", path: '/parent-issued-books', badge: issuedCount },
    { c: '#be123c', icon: 'bx bx-rupee', title: 'My Fines', desc: 'View pending fines', path: '/parent-fines' },
    { c: '#0369a1', icon: 'bx bx-credit-card', title: 'My Payments', desc: 'Your payment history', path: '/parent-payments' },
    { c: '#4338ca', icon: 'bx bx-id-card', title: 'Library Card', desc: 'Your membership card', path: '/parent-library-card' }
  ];

  return (
    <div className="container-fluid mt-3 pd-page">
      <style>{`
        .pd-page { animation: pdFade .5s ease both; padding: 4px 16px 24px 24px; }

        /* ── Hero banner (blue palette matched to sidebar) ── */
        .pd-hero {
          position: relative; overflow: hidden;
          display: flex; align-items: center; justify-content: space-between; gap: 20px;
          min-height: 230px;
          background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 55%, #3b82f6 120%);
          color: #fff; border-radius: 22px; padding: 30px;
          box-shadow: 0 18px 40px rgba(30, 58, 138, .35);
          animation: pdUp .5s ease both;
        }
        .pd-hero-left { display: flex; align-items: center; gap: 18px; z-index: 1; min-width: 0; }
        .pd-eyebrow { font-size: 11.5px; letter-spacing: .16em; text-transform: uppercase; color: #bfdbfe; font-weight: 700; }
        .pd-hero h3 { color: #fff; font-weight: 800; font-size: 1.7rem; margin: 3px 0 4px; letter-spacing: -.3px; }
        .pd-hero p { color: rgba(255,255,255,.85); margin: 0; font-size: 13.5px; max-width: 380px; }
        .pd-avatar {
          width: 74px; height: 74px; border-radius: 50%; flex-shrink: 0;
          overflow: hidden; background: rgba(255,255,255,.2);
          display: flex; align-items: center; justify-content: center;
          border: 3px solid rgba(255,255,255,.7);
          box-shadow: 0 6px 18px rgba(30, 58, 138, .4);
          animation: pdPop .6s cubic-bezier(.18,.89,.32,1.28) both;
        }
        .pd-avatar img { width: 100%; height: 100%; object-fit: cover; }
        .pd-wave { display: inline-block; transform-origin: 70% 70%; animation: pdWave 2.2s ease-in-out infinite; }

        .pd-pills { display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap; }
        .pd-pill {
          display: inline-flex; align-items: center; gap: 7px;
          background: rgba(255,255,255,.16); border: 1px solid rgba(191,219,254,.45);
          padding: 6px 13px; border-radius: 999px; font-size: 12.5px; font-weight: 700;
          color: #eff6ff; backdrop-filter: blur(4px);
        }
        .pd-pill i { font-size: 15px; }
        .pd-pill b { font-weight: 800; color: #fff; }

        /* ── Section heading ── */
        .pd-section { display: flex; align-items: baseline; gap: 10px; margin: 22px 2px 14px; }
        .pd-section h4 { font-weight: 800; color: #1e3a8a; margin: 0; font-size: 1.15rem; }
        .pd-section span { color: #64748b; font-size: 13px; }

        /* ── Tile grid ── */
        .pd-grid { display: grid; grid-template-columns: repeat(6, 1fr); gap: 14px; }

        .pd-tile {
          position: relative; overflow: hidden; text-align: left; width: 100%;
          display: flex; flex-direction: column; align-items: flex-start; gap: 10px;
          background: #fff; border: 1px solid #eef1f8; border-radius: 16px; padding: 16px 14px;
          cursor: pointer; box-shadow: 0 8px 22px rgba(16, 16, 39, .06);
          transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
          animation: pdUp .5s ease both;
        }
        .pd-tile::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: var(--c); }
        .pd-tile:hover {
          transform: translateY(-5px);
          box-shadow: 0 16px 34px color-mix(in srgb, var(--c) 22%, transparent);
          border-color: color-mix(in srgb, var(--c) 35%, #eef1f8);
        }
        .pd-tile-ico {
          width: 46px; height: 46px; flex-shrink: 0; border-radius: 13px;
          display: flex; align-items: center; justify-content: center;
          font-size: 23px; color: #fff;
          background: linear-gradient(135deg, var(--c), color-mix(in srgb, var(--c) 70%, #000 12%));
          box-shadow: 0 8px 16px color-mix(in srgb, var(--c) 34%, transparent);
          transition: transform .2s ease;
        }
        .pd-tile:hover .pd-tile-ico { transform: scale(1.06) rotate(-3deg); }
        .pd-tile-txt { display: flex; flex-direction: column; min-width: 0; width: 100%; }
        .pd-tile-title { font-weight: 800; color: #1e293b; font-size: .95rem; display: flex; align-items: center; gap: 8px; }
        .pd-tile-badge {
          font-style: normal; font-size: 11px; font-weight: 800; padding: 1px 8px; border-radius: 999px;
          background: color-mix(in srgb, var(--c) 16%, #fff); color: var(--c);
        }
        .pd-tile-desc { color: #64748b; font-size: 12px; margin-top: 3px; line-height: 1.35; }
        .pd-tile-go { display: none; }

        .pd-tile:nth-child(1){animation-delay:.04s}.pd-tile:nth-child(2){animation-delay:.09s}
        .pd-tile:nth-child(3){animation-delay:.14s}.pd-tile:nth-child(4){animation-delay:.19s}
        .pd-tile:nth-child(5){animation-delay:.24s}.pd-tile:nth-child(6){animation-delay:.29s}

        /* ── Animated reading scene ── */
        .pd-hero-art {
          position: absolute; right: 24px; bottom: 0;
          width: 250px; height: auto; pointer-events: none;
          animation: artFloat 5s ease-in-out infinite;
        }
        .pd-hero-art .art-girl { animation: artFloat 4s ease-in-out infinite; transform-origin: bottom center; }
        .pd-hero-art .art-head { animation: artNod 3.6s ease-in-out infinite; transform-origin: 86px 102px; }
        .pd-hero-art .art-book-float { animation: artBook 3.4s ease-in-out infinite; transform-origin: 138px 28px; }
        .pd-hero-art .art-page { animation: artPage 2.8s ease-in-out infinite; transform-origin: 86px 138px; }
        .pd-hero-art .art-plant { animation: artSway 4.5s ease-in-out infinite; transform-origin: 150px 164px; }
        .pd-hero-art .art-twinkle { animation: artTwinkle 2.4s ease-in-out infinite; }
        .pd-hero-art .art-twinkle.t2 { animation-delay: .6s; }
        .pd-hero-art .art-twinkle.t3 { animation-delay: 1.2s; }

        @keyframes artFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
        @keyframes artNod   { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(-4deg); } }
        @keyframes artSway  { 0%,100% { transform: rotate(-2deg); } 50% { transform: rotate(2deg); } }
        @keyframes artBook  { 0%,100% { transform: translateY(0) rotate(-4deg); } 50% { transform: translateY(-7px) rotate(4deg); } }
        @keyframes artPage  { 0%,70%,100% { transform: scaleX(1); } 35% { transform: scaleX(.05); } }
        @keyframes artTwinkle { 0%,100% { opacity: .2; transform: scale(.7); } 50% { opacity: 1; transform: scale(1); } }

        @keyframes pdFade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pdUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pdPop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: scale(1); } }
        @keyframes pdWave {
          0%,60%,100% { transform: rotate(0deg); }
          10%,30% { transform: rotate(14deg); }
          20% { transform: rotate(-8deg); }
          40% { transform: rotate(10deg); }
          50% { transform: rotate(-4deg); }
        }

        @media (max-width: 1280px) { .pd-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 991px)  { .pd-hero-art { display: none; } }
        @media (max-width: 768px)  { .pd-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 575px)  {
          .pd-hero { flex-direction: column; text-align: center; padding: 22px; }
          .pd-hero-left { flex-direction: column; }
          .pd-pills { justify-content: center; }
          .pd-grid { grid-template-columns: 1fr; }
        }
        @media (prefers-reduced-motion: reduce) {
          .pd-page, .pd-hero, .pd-tile, .pd-avatar, .pd-wave,
          .pd-hero-art, .pd-hero-art * { animation: none !important; }
        }
      `}</style>

      {/* ── Hero banner ── */}
      <div className="pd-hero">
        <div className="pd-hero-left">
          <div className="pd-avatar">
            {userImg ? (
              <img src={getImageUrl(userImg)} alt="User" />
            ) : (
              <i className="bx bx-user" style={{ fontSize: 38, color: '#fff' }} />
            )}
          </div>
          <div>
            <div className="pd-eyebrow">Welcome back</div>
            <h3>Hello, {displayName} <span className="pd-wave">👋</span></h3>
            <p>Explore books, track your requests and manage your library account.</p>
            <div className="pd-pills">
              <span className="pd-pill"><i className="bx bx-book-reader" /> <b>{issuedCount}</b> Issued</span>
              <span className="pd-pill"><i className="bx bx-id-card" /> Member</span>
            </div>
          </div>
        </div>

        {/* Animated scene: a girl reading a book — modern flat style */}
        <svg className="pd-hero-art" viewBox="0 0 260 180" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          {/* soft glow backdrop */}
          <circle cx="118" cy="92" r="78" fill="rgba(255,255,255,.07)" />
          <circle cx="118" cy="92" r="56" fill="rgba(255,255,255,.06)" />

          {/* back bookshelf */}
          <g className="art-shelf">
            <rect x="170" y="26" width="78" height="104" rx="9" fill="rgba(255,255,255,.12)" />
            <line x1="170" y1="62" x2="248" y2="62" stroke="rgba(255,255,255,.22)" strokeWidth="2" />
            <line x1="170" y1="98" x2="248" y2="98" stroke="rgba(255,255,255,.22)" strokeWidth="2" />
            <rect x="178" y="36" width="7" height="24" rx="2" fill="#eef4ff" />
            <rect x="187" y="32" width="7" height="28" rx="2" fill="#6366f1" />
            <rect x="196" y="38" width="7" height="22" rx="2" fill="#3b82f6" />
            <rect x="206" y="34" width="7" height="26" rx="2" fill="#3b82f6" />
            <rect x="216" y="32" width="7" height="28" rx="2" fill="#1e3a8a" />
            <rect x="226" y="36" width="7" height="24" rx="2" fill="#93c5fd" />
            <rect x="178" y="72" width="7" height="24" rx="2" fill="#3b82f6" />
            <rect x="187" y="68" width="7" height="28" rx="2" fill="#3b82f6" />
            <rect x="196" y="74" width="7" height="22" rx="2" fill="#eef4ff" />
            <rect x="207" y="70" width="7" height="26" rx="2" fill="#6366f1" />
            <rect x="217" y="72" width="7" height="24" rx="2" fill="#93c5fd" />
            <rect x="227" y="68" width="7" height="28" rx="2" fill="#1e3a8a" />
          </g>

          {/* potted plant */}
          <g className="art-plant">
            <path d="M150 150 q4 -26 0 -34" stroke="#3b82f6" strokeWidth="2.5" fill="none" />
            <ellipse cx="150" cy="112" rx="6" ry="9" fill="#3b82f6" transform="rotate(-22 150 112)" />
            <ellipse cx="158" cy="118" rx="6" ry="9" fill="#93c5fd" transform="rotate(20 158 118)" />
            <ellipse cx="143" cy="120" rx="5" ry="8" fill="#93c5fd" transform="rotate(-40 143 120)" />
            <path d="M143 150 L157 150 L154 164 L146 164 Z" fill="#6366f1" />
          </g>

          {/* floating book */}
          <g className="art-book-float">
            <rect x="120" y="16" width="36" height="25" rx="4" fill="#eef4ff" />
            <rect x="120" y="16" width="36" height="25" rx="4" fill="none" stroke="#6366f1" strokeWidth="1.5" opacity=".5" />
            <line x1="138" y1="18" x2="138" y2="39" stroke="#6366f1" strokeWidth="2" />
            <line x1="125" y1="24" x2="134" y2="24" stroke="#6366f1" strokeWidth="1.5" opacity=".7" />
            <line x1="142" y1="24" x2="151" y2="24" stroke="#6366f1" strokeWidth="1.5" opacity=".7" />
            <line x1="125" y1="30" x2="134" y2="30" stroke="#6366f1" strokeWidth="1.5" opacity=".5" />
            <line x1="142" y1="30" x2="151" y2="30" stroke="#6366f1" strokeWidth="1.5" opacity=".5" />
          </g>

          {/* sparkles (4-point stars) */}
          <g fill="#fde047">
            <path className="art-twinkle t1" transform="translate(108 30)" d="M0 -4 L1.1 -1.1 L4 0 L1.1 1.1 L0 4 L-1.1 1.1 L-4 0 L-1.1 -1.1 Z" />
            <path className="art-twinkle t2" transform="translate(166 16)" d="M0 -3 L0.9 -0.9 L3 0 L0.9 0.9 L0 3 L-0.9 0.9 L-3 0 L-0.9 -0.9 Z" />
            <path className="art-twinkle t3" transform="translate(96 56)" d="M0 -3 L0.9 -0.9 L3 0 L0.9 0.9 L0 3 L-0.9 0.9 L-3 0 L-0.9 -0.9 Z" />
          </g>

          {/* girl reading — modern flat character */}
          <g className="art-girl">
            <ellipse cx="86" cy="158" rx="56" ry="10" fill="rgba(255,255,255,.16)" />
            <ellipse cx="86" cy="153" rx="44" ry="11" fill="#3b82f6" />
            <path d="M52 150 Q86 138 120 150 Q114 162 86 162 Q58 162 52 150 Z" fill="#1e3a8a" />
            <path d="M70 150 Q86 144 102 150" stroke="#172554" strokeWidth="2" fill="none" />
            <path d="M62 138 Q60 110 86 108 Q112 110 110 138 Z" fill="#6366f1" />
            <path d="M62 138 Q60 110 86 108 Q112 110 110 138 Z" fill="none" stroke="#4f46e5" strokeWidth="1" opacity=".4" />
            <path d="M66 120 Q58 130 64 140" stroke="#6366f1" strokeWidth="9" fill="none" strokeLinecap="round" />
            <path d="M106 120 Q114 130 108 140" stroke="#6366f1" strokeWidth="9" fill="none" strokeLinecap="round" />
            <circle cx="64" cy="141" r="4.5" fill="#fcd9b8" />
            <circle cx="108" cy="141" r="4.5" fill="#fcd9b8" />
            <g className="art-head">
              <path d="M68 90 Q66 70 86 70 Q106 70 104 90 L104 116 Q98 110 96 100 L96 92 Q96 82 86 82 Q76 82 76 92 L76 100 Q74 110 68 116 Z" fill="#4f4a35" />
              <rect x="82" y="98" width="8" height="10" rx="3" fill="#fcd9b8" />
              <circle cx="86" cy="90" r="13" fill="#fcd9b8" />
              <circle cx="79" cy="93" r="2.4" fill="#cbb8a0" opacity=".7" />
              <circle cx="93" cy="93" r="2.4" fill="#cbb8a0" opacity=".7" />
              <path d="M80 89 q2.5 2.5 5 0" stroke="#3b2a20" strokeWidth="1.8" fill="none" strokeLinecap="round" />
              <path d="M88 89 q2.5 2.5 5 0" stroke="#3b2a20" strokeWidth="1.8" fill="none" strokeLinecap="round" />
              <path d="M83 96 q3 2.5 6 0" stroke="#6366f1" strokeWidth="1.6" fill="none" strokeLinecap="round" />
              <path d="M73 88 Q74 72 86 72 Q98 72 99 88 Q95 80 86 80 Q77 80 73 88 Z" fill="#4f4a35" />
              <circle cx="100" cy="78" r="6" fill="#4f4a35" />
              <circle cx="72" cy="78" r="6" fill="#4f4a35" />
            </g>
            <g className="art-openbook">
              <path d="M56 134 L86 126 L86 150 L56 156 Z" fill="#f1f6ff" />
              <path d="M116 134 L86 126 L86 150 L116 156 Z" fill="#ffffff" />
              <path d="M86 126 L86 150" stroke="#bfdbfe" strokeWidth="1.6" />
              <path className="art-page" d="M86 126 L114 133 L114 149 L86 150 Z" fill="#dbeafe" />
              <line x1="62" y1="138" x2="80" y2="133" stroke="#bfdbfe" strokeWidth="1.4" />
              <line x1="62" y1="143" x2="80" y2="138" stroke="#bfdbfe" strokeWidth="1.4" />
              <line x1="92" y1="133" x2="110" y2="138" stroke="#bfdbfe" strokeWidth="1.4" />
              <line x1="92" y1="138" x2="110" y2="143" stroke="#bfdbfe" strokeWidth="1.4" />
            </g>
          </g>
        </svg>
      </div>

      {/* ── Quick access tiles ── */}
      <div className="pd-section">
        <h4>Quick Access</h4>
        {/* <span>Jump straight to a common task</span> */}
      </div>

      <div className="pd-grid">
        {tiles.map((t) => (
          <button key={t.title} className="pd-tile flex-direction-unset" style={{ '--c': t.c }} onClick={() => navigate(t.path)}>
            <span className="pd-tile-ico"><i className={t.icon} /></span>
            <span className="pd-tile-txt">
              <span className="pd-tile-title">
                {t.title}
                {t.badge !== undefined && <em className="pd-tile-badge">{t.badge}</em>}
              </span>
              <span className="pd-tile-desc">{t.desc}</span>
            </span>
            <i className="bx bx-chevron-right pd-tile-go" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ParentDashboard;